import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from 'recharts';
import { batchRequest } from '../../../../../api/ApiService';
import { Loader } from 'react-loaders';

class RevenuesStep4 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      freeSpace: 0,
      teamUnits: 0,
      teamUnitsPercent: 0,
      totalDemand: 0,
    };
  }

  componentDidMount() {
    const { activeRound } = this.props;

    batchRequest([
      `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}static/total_demand/`,
    ])
      .then(res => {
        const inventoryBalances = res[0].body;
        const teamUnits = inventoryBalances
          .map(i => Math.abs(Number(i.available_for_sale || 0)))
          .reduce((prev, curr) => prev + curr, 0);

        const totalDemandRaw = res[1].body;
        const totalDemandValue = totalDemandRaw.find(i => Number(i.round_number) === activeRound);
        const totalDemand = Number(totalDemandValue.total);

        const teamUnitsPercent = Number((teamUnits / totalDemand * 100).toFixed(2));
        const freeSpace = 100 - teamUnitsPercent;

        this.setState({
          loaded: true,
          freeSpace,
          teamUnits,
          teamUnitsPercent,
          totalDemand,
        })
      })
      .catch(err => {});
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  renderLabel = (props) => {
    const {
      cx, cy, midAngle, outerRadius, value, name, index, payload,
    } = props;
    const { originalValue } = payload;
    const { totalDemand } = this.state;
    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 35;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
    const hideLabel = payload.hideLabel || false;

    return (
      <g>
        {index === 0 && (
          <text
            x={cx}
            y={cy}
            dy={-10}
            textAnchor="middle"
            className="chartCenterLabel"
          >Total Units</text>
        )}
        {index === 0 && (
          <text
            x={cx}
            y={cy}
            dy={10}
            textAnchor="middle"
            className="chartCenterLabel"
          >Demanded</text>
        )}
        {index === 0 && (
          <text
            x={cx}
            y={cy}
            dy={30}
            textAnchor="middle"
            className="chartCenterLabel"
          >{Number((totalDemand / 1000000).toFixed(2))}M</text>
        )}
        {!hideLabel && <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke="rgba(0, 27, 59, 0.94)" fill="none" />}
        {!hideLabel && (
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 20}
            y={ey}
            dy={-10}
            textAnchor={textAnchor}
            className="chartLabel"
          >{`${value}%`}</text>
        )}
        {!hideLabel && (
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 20}
            y={ey}
            dy={10}
            textAnchor={textAnchor}
            className="chartDescription1"
          >{this.numberWithCommas(originalValue)}</text>
        )}
        {!hideLabel && (
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 20}
            y={ey}
            dy={32}
            textAnchor={textAnchor}
            className="chartDescription2"
          >{name}</text>
        )}
      </g>
    );
  }

  render() {
    const {
      loaded,
      freeSpace,
      teamUnits,
      teamUnitsPercent,
    } = this.state;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="REVENUES"
        hideAlert={true}
        subTitle="Building Inventory to Meet Demand"
        paragraph1={(
          <Fragment>
            Let's now look at the amount of inventory available for sale. Here's what customers
            demanded this past round in relation to the number of units you had available for
            sale (i.e. volume).
          </Fragment>
        )}
        paragraph2={(
          <Fragment>
            Given customers' demand and other Research data, could your team have produced more
            inventory to hit your revenue target especially if your team believed it did not make
            sense to increase your selling prices?
          </Fragment>
        )}
        visual={(
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie
                data={[
                  { name: 'Free space', hideLabel: true, value: freeSpace },
                  { name: 'Team\'s units available for sale', originalValue: teamUnits, value: teamUnitsPercent }
                ]}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                fill="#8884d8"
                dataKey="value"
                label={this.renderLabel}
                labelLine={false}
                startAngle={90}
                endAngle={450}
              >
                ${['#52c5cd', '#f9c151'].map((color, index) => (
                  <Cell key={`pie-cell-${index}`} fill={color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        )}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default RevenuesStep4;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/revenues/step4.js